<ng-container>
  <header
    class="bg-primary top-0 right-0 left-0 flex h-32 items-center justify-between px-4 shadow-md"
  >
    <div class="ml-12 flex items-center">
      <img
        src="assets/media/enac-logo.png"
        alt="Logo di Ente Nazionale per l'Aviazione Civile"
        class="mr-8 h-24"
      />
      <h1 class="text-xl font-medium text-white">
        {{ 'TITLE' | translate }}
      </h1>
    </div>

    <div>
      @if (!authStateService.isLoggedIn()) {
        <button
          mat-raised-button
          class="bg-primary font-bold"
          (click)="login()"
        >
          <mat-icon class="mr-2">login</mat-icon>
          {{ 'AUTHENTICATION.ACTIONS.LOGIN' | translate }}
        </button>
      } @else {
        <div class="flex items-center">
          <p class="text-white" aria-label="Nome utente">
            {{
              authStateService.user()?.details?.firstName +
                ' ' +
                authStateService.user()?.details?.lastName
            }}
          </p>
          <button
            mat-raised-button
            class="bg-primary ml-4 font-bold"
            (click)="logout()"
          >
            <mat-icon class="mr-2">logout</mat-icon>
            {{ 'AUTHENTICATION.ACTIONS.LOGOUT' | translate }}
          </button>
        </div>
      }
    </div>
  </header>
</ng-container>
